<template>
<div class="chapter">
<div class="inner_page">
<div class="prelims-page" id="d2-d5f88a5f148ed-d1e230"><span id="pageii">
<h3 class="books-by-head "><em><em class="char-italic italic">Recent titles by Mitch Silver</em></em></h3>
<p class="books-by-text ">IN SECRET SERVICE</p>
<p class="books-by-text ">THE BOOKWORM</p>
<p class="books-by-text-space-after ">THE APOLLO DECEPTION *<em><em class="char-italic italic"></em></em></p>
<p class="books-by-text "><em><em class="char-italic italic">* available from Severn House</em></em></p></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781448303595_epub_alb.vue?51a95d10